/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Empty_FolderInputs */

const en_dropbox_empty_folder = /** @type {(inputs: Dropbox_Empty_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder has no files.`)
};

const es_dropbox_empty_folder = /** @type {(inputs: Dropbox_Empty_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta carpeta no tiene archivos.`)
};

/**
* | output |
* | --- |
* | "This folder has no files." |
*
* @param {Dropbox_Empty_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_empty_folder = /** @type {((inputs?: Dropbox_Empty_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Empty_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_empty_folder(inputs)
	return en_dropbox_empty_folder(inputs)
});